import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiChevronDown,
  FiCode,
  FiTrendingUp,
  FiX,
} from "react-icons/fi";
import { links } from "./Mylinks";

const groupDetails = {
  "Design & Development": {
    icon: <FiCode aria-hidden="true" />,
    copy: "Digital products designed to perform.",
  },
  Marketing: {
    icon: <FiTrendingUp aria-hidden="true" />,
    copy: "Growth systems built around real results.",
  },
};

const NavLinks = ({ onNavigate = () => {} }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleTriggerClick = () => {
    setDismissed(false);
    setOpenMenu((isOpen) => !isOpen);
  };

  const handleClose = () => {
    setOpenMenu(false);
    setDismissed(true);
  };

  const handleMouseLeave = () => {
    setDismissed(false);
    setOpenMenu(false);
  };

  return (
    <>
      {links.map((link) => (
        <li
          className={`site-nav__services ${openMenu ? "is-open" : ""} ${dismissed ? "is-dismissed" : ""}`}
          key={link.name}
          onMouseLeave={handleMouseLeave}
        >
          <button
            className="site-nav__link site-nav__services-trigger"
            type="button"
            onClick={handleTriggerClick}
            aria-expanded={openMenu}
          >
            {link.name}
            <FiChevronDown aria-hidden="true" />
          </button>

          {link.submenu ? (
            <div className="site-nav__mega">
              <button
                className="site-nav__mega-close"
                type="button"
                onClick={handleClose}
                aria-label="Close services menu"
              >
                <FiX aria-hidden="true" />
              </button>
              <div className="site-nav__mega-intro">
                <div>
                  <span>Capabilities</span>
                  <strong>Everything you need to move forward.</strong>
                </div>
                <Link to="/contactus" onClick={onNavigate}>
                  Talk to an expert <FiArrowRight aria-hidden="true" />
                </Link>
              </div>

              <div className="site-nav__mega-grid">
                {link.sublinks.map((group) => {
                  const details = groupDetails[group.Head];
                  return (
                    <div className="site-nav__mega-group" key={group.Head}>
                      <div className="site-nav__mega-heading">
                        <span>{details?.icon}</span>
                        <div>
                          <strong>{group.Head}</strong>
                          <small>{details?.copy}</small>
                        </div>
                      </div>
                      <div className="site-nav__mega-links">
                        {group.sublink.map((item) => (
                          <Link to={item.link} key={item.name} onClick={onNavigate}>
                            <span>{item.name.trim()}</span>
                            <FiArrowRight aria-hidden="true" />
                          </Link>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </li>
      ))}
    </>
  );
};

export default NavLinks;
